export default __webpack_public_path__ + "static/media/search-icon.53b4ff5c.svg";